import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class NotificationService {
  static loadNotifications(params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        query.append(key, value);
      }
    });
    const url = `${endpoints.BASE_URL}${
      endpoints.GET_NOTIFICATIONS
    }?${query.toString()}`;

    return axios.get(url).then((response) => response.data);
  }
}

export default NotificationService;
